import styled from 'styled-components';

export const HeadingStyles = styled.div`
  color: var(--primary);
`;